import React, { memo, useMemo } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';

import { useCustomer } from 'common/hooks';
import { UserAvailableFeatures } from 'common/hooks/useCustomer/useCustomer.hook';

import { routes } from './routes.constants';

interface FeautureRouteProps extends RouteProps {
  feature: UserAvailableFeatures;
  fallbackRoute?: string;
}

const FeautureRoute: React.FC<React.PropsWithChildren<FeautureRouteProps>> = ({ feature, fallbackRoute, ...rest }) => {
  const { checkFeaturesAvailability } = useCustomer();

  const isFeatureAvailable = useMemo(() => checkFeaturesAvailability(feature), [checkFeaturesAvailability, feature]);

  if (!isFeatureAvailable) return <Redirect to={fallbackRoute ?? routes.getHome()} />;

  return <Route {...rest} />;
};

export default memo(FeautureRoute);
